
export const AUTH_ENDPOINTS = {
    SIGN_UP: '/student-signup',
    SIGN_VERIFY: '/student-verify',
    EMAIL_VERIFY_RESEND: '/resend-code',
    LOGIN: '/login',
    FORGOT_PASSWORD: '/verify-student-cnic',
    FORGOT_PASSWORD_VERIFY: '/forgot-password',
    VERIFY_OTP: '/forget-password-verify-otp',
    RESEND_OTP: '/resend-forget-password-otp',
    RESET_PASSWORD: '/reset-password',
    CHECK_REGISTRATION: '/check-registration-allowed',
    CHECK_ELIGIBILITY: '/check-student-eligibility',
};

export const DASHBOARD_ENDPOINTS = {
    APPLICATION_STATUS: '/get_application_status',
    ASSETS_STATUS: '/get-assigned-assets',
    APPLICATION_LIST: '/get-applications-list',
    GET_FOCAL_PERSON: '/get-focal-person'
};

export const HOME_ENDPOINTS = {
    CARD_STATUS: '/card-stats'
};

// Application Status Endpoints
export const APPLICATION_STATUS_ENDPOINT = {

    CITIES: '/get-university-city-list',
    UNIVERSITIES: (cityId) => `/get-university-list?city_id=${cityId}`,
    CAMPUSES: (universityId) => `/get-campus-list?university_id=${universityId}`,
    DEGREES: '/get-degree-level',
    YEARS: '/get-study-year',

    DEPARTMENTS: ({ campusId, universityId }) =>
        `/get-department-list?campus_id=${campusId}&university_id=${universityId}`,

    SEARCH_STATUS: ({ cityId, universityId, campusId, deptId, degreeLevelId, yearOfStudy }) => {
        const params = new URLSearchParams({
            city_id: cityId,
            university_id: universityId,
            campus_id: campusId,
            department_id: deptId,
            degree_level_id: degreeLevelId,
            year_of_study: yearOfStudy,
        });
        return `/search-applications-status?${params.toString()}`;
    },
};

// Profile Endpoints
export const PROFILE_ENDPOINT = {
    GET_INFO: '/get-student-info',
    UPLOAD_IMAGE: '/update-profile-photo',
    UPDATE_PASSWORD: '/update-password',
};

export const COMMON_ENDPOINTS = {
    SEARCH_FOCAL_PERSON: (city_id, university_id) => `/search-focal-person?city_id=${city_id}&university_id=${university_id}`,
    LAPTOP_ISSUED: '/is-laptop-issued',
};

export const STUDENT_ENDPOINTS = {
    PROVINCES: '/get-province-list',
    CITIES: (provinceId) => `/get-domicile-city-list?province_id=${provinceId}`,
    ALL_CITIES: '/get-city-list',
    UNIVERSITIES: (cityId) => `/get-student-university-list?city_id=${cityId}`,
    CAMPUSES: (universityId) => `/get-campus-list?university_id=${universityId}`,
    DEPARTMENTS: (universityId, campusId) => `/get-campus-department-list?university_id=${universityId}&campus_id=${campusId}`,
    DEGREE_LEVELS: (departmentId) => `/get-degree-levels-for-department?department_id=${departmentId}`,
    DEGREE_PROGRAMS: (universityId, departmentId, degreeLevelId) =>
        `/get-degree-program-entrolled?university_id=${universityId}&department_id=${departmentId}&degree_level_id=${degreeLevelId}`,
    PROGRAM_DURATION: (degreeProgramId) => `/get-program-duration?degree_program_id=${degreeProgramId}`,
    SEMESTER_SYSTEM: '/get-semester-system',
    SEMESTER_LIST: (programDuration, semesterMethod) => `/get-annual-or-semester-list?program_duration=${programDuration}&semester_method=${semesterMethod}`,
    GRADING_SYSTEM: '/get-grading-system',
    REGISTRATION: '/student-registration',
    UPDATE_APPLICATION: '/update-laptop-request',
    APPLICATION_DETAIL: (appId) => `/get-application-detail?application_id=${appId}`,
};